// extracted by mini-css-extract-plugin
module.exports = {"article":"InsuranceDetailWrapper_article__qR42u","type-white":"InsuranceDetailWrapper_type-white__ESulF","inner":"InsuranceDetailWrapper_inner__Q8m9a"};